import React, { useRef } from 'react';

// tools
import uniqid from '../../../../helpers/uniqid';

const ButtonIconRadio = ({ children, onChange, checked, isSquare = false }) => {
    const uuid = useRef(uniqid());
    const classes = ['appButton__iconRadioFlat']

    if (isSquare) {
        classes.push('appButton__icon--square')
    }

    return(
        <label htmlFor={uuid.current} className={classes.join(' ')}>
            <input type="checkbox" id={uuid.current} onChange={onChange} checked={checked}/>
            {children}
        </label>
    )
}

export default ButtonIconRadio;